import type { SVGProps } from "react";

export function IconBlack3PackagesAlt(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.25 12.75V21.75H11.25V12.75H2.25ZM12.75 21.75H21.75V12.75H12.75V21.75ZM17 2.25H7V11.25H17V2.25Z"
        fill="#23232C"
      />
    </svg>
  );
}
